(function() {
  if (window.__cartAttributesHelperAttached) return;
  window.__cartAttributesHelperAttached = true;

  var pendingCount = 0;
  var saveQueue = Promise.resolve();

  function setCheckoutBusy(isBusy) {
    document.querySelectorAll('button[name="checkout"], .checkout-button').forEach(function(button) {
      button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    });
  }

  function updatePendingCount(delta) {
    pendingCount = Math.max(0, pendingCount + delta);
    setCheckoutBusy(pendingCount > 0);
  }

  function sameAttributeCheckboxes(key) {
    return Array.prototype.filter.call(document.querySelectorAll('.cart-attribute-checkbox'), function(checkbox) {
      return checkbox.getAttribute('data-attribute-key') === key;
    });
  }

  function saveCartAttribute(key, value) {
    updatePendingCount(1);

    saveQueue = saveQueue.catch(function() {}).then(function() {
      var attributes = {};
      attributes[key] = value;

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      }).then(function(response) {
        if (!response.ok) {
          throw new Error('Cart attribute save failed');
        }

        return response.json();
      });
    });

    return saveQueue.catch(function(error) {
      console.error('Cart attribute save error:', error);
    }).finally(function() {
      updatePendingCount(-1);
    });
  }

  function waitForPendingSaves() {
    return saveQueue.catch(function() {});
  }

  document.addEventListener('change', function(event) {
    if (!event.target.classList.contains('cart-attribute-checkbox')) return;

    var checkbox = event.target;
    var key = checkbox.getAttribute('data-attribute-key');
    var checkedValue = checkbox.getAttribute('data-checked-value') || 'Sí';
    var uncheckedValue = checkbox.getAttribute('data-unchecked-value') || '';
    var value = checkbox.checked ? checkedValue : uncheckedValue;

    sameAttributeCheckboxes(key).forEach(function(matchingCheckbox) {
      matchingCheckbox.checked = checkbox.checked;
    });

    saveCartAttribute(key, value);
  });

  document.addEventListener('submit', function(event) {
    var form = event.target;
    var submitter = event.submitter;
    var isCheckoutSubmit = submitter && submitter.getAttribute('name') === 'checkout';

    if (!isCheckoutSubmit) return;
    if (form.getAttribute('data-cart-attributes-submitting') === 'true') return;
    if (pendingCount === 0) return;

    event.preventDefault();

    waitForPendingSaves().then(function() {
      form.setAttribute('data-cart-attributes-submitting', 'true');

      if (form.requestSubmit && submitter) {
        form.requestSubmit(submitter);
        return;
      }

      var checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'checkout';
      form.appendChild(checkoutInput);
      form.submit();
    });
  }, true);
})();
